export default [{
  path: '/admin/login',
  name: 'Login',
  component: () => import('@/views/login/login'),
  meta: {
    title: '站点登录',
    keepAlive: false,
    auth: false,
    headType: -1
  },
  alias: ['/', '/admin']
}]



// WEBPACK FOOTER //
// ./src/router/login.js